var cartStoreModule = {
    state: {
        items: [],
        totals: {
            count: 0,
            itemsCount: 0
        },
        free_shipping: {
            has_free_shipping: false
        },
        hasTotalsLoaded: false,
    },
    actions: {
        fetchCartTotals: function () {
            $.get(Eshop.options.baseUrl + 'cart/fetch-totals', {}, function (response) {
                this.commit('cartTotals', response.data.totals);
                this.commit('freeShipping', response.data.free_shipping);
            }.bind(this), 'json');
        },
        fetchCartProducts: function () {
            $.get(Eshop.options.baseUrl + 'cart/fetch-products', {}, function (response) {
                this.commit('cartItems', Object.values(response.data.items));

                rEvent.dispatch('Cart.fetchedProducts', {
                    response: response
                });
            }.bind(this), 'json');
        },
        fetchCart: function (context) {
            context.dispatch('fetchCartTotals');
            context.dispatch('fetchCartProducts');
        },
        addCartItem: function (context, data, callback) {
            var index = _.findIndex(store.state.products.products, function (item) {
                return item.id == data.product_id;
            }),
                product = store.state.products.products[index];

            $.post(Eshop.options.baseUrl + 'cart-products/add', data, function (response) {
                store.dispatch('fetchCart');

                rEvent.dispatch('Cart.addedProduct', {
                    response: response,
                    product: product
                });
            }.bind(this), 'json');
        },
        removeCartItem: function (data, cartId) {
            var index = _.findIndex(data.state.items, function (item) {
                return item.cart_id == cartId;
            });

            if (index == -1) {
                return false;
            }

            var product = data.state.items[index];

            $.get(Eshop.options.baseUrl + 'remove-item/' + cartId, {}, function (response) {
                data.commit('removeCartItem', index);
                store.dispatch('fetchCart');

                rEvent.dispatch('Cart.removedProduct', {
                    response: response,
                    product: product
                });
            }.bind(this), 'json');
        },
        changeProductQuantity: function (context, product) {
            rEvent.dispatch('Cart.beforeUpdateProduct', product);
            $.post(Eshop.options.baseUrl + 'change-item-quantity/' + product.cart_id, { quantity: product.quantity }, function (response) {
                store.dispatch('fetchCart');

                rEvent.dispatch('Cart.updatedProduct', {
                    response: response,
                    product: product
                });
            }, 'json');
        }
    },
    mutations: {
        cartTotals: function (state, data) {
            state.totals = data;
            state.hasTotalsLoaded = true;
        },
        freeShipping: function (state, data) {
            state.free_shipping = data;
        },
        cartItems: function (state, data) {
            state.items = data;
        },
        addCartItem: function (state, data) {
            state.items.push(data);
        },
        removeCartItem: function (state, index) {
            state.items.splice(index, 1);
            state.totals.count--;
        },
        changedProductQuantity: function () { }
    },
    getters: {
        isEmpty: function (state, getters) {
            return getters.count == 0;
        },
        count: function (state) {
            return state.totals.count;
        },
        itemsCount: function (state) {
            if (state.items) {
                return state.items.reduce(function(count, item) {
                    return count + parseInt(item.quantity);
                }, 0);
            }

            return 0;
        },
        subtotalPrice: function (state) {
            return state.totals.subtotal;
        },
        totalPrice: function (state) {
            return state.totals.total;
        },
        taxes: function (state) {
            return state.totals.taxes;
        },
        cartProducts: function (state) {
            return state.items.filter(function (item) {
                return item.type == 'product';
            });
        },
        hasFreeShipping: function (state) {
            return state.free_shipping.has_free_shipping;
        },
        freeShippingText: function (state) {
            return state.free_shipping.has_free_shipping ? state.free_shipping.free_shipping_text : state.free_shipping.not_free_shipping_text;
        },
        totals: function(state) {
            return state.totals;
        },
        hasTotalsLoaded: function(state) {
            return state.hasTotalsLoaded;
        }
    }
};

var CartComponent = Vue.component('cart', {
    props: [],
    components: {
        'cart-item': CartItemComponent
    },
    data: function () {
        return {};
    },
    created: function () {
    },
    computed: {
        items: function () {
            return this.$store.state.cart.items;
        },
        isEmpty: function () {
            return this.$store.getters.isEmpty;
        },
        count: function () {
            return this.$store.getters.count;
        },
        itemsCount: function () {
            return this.$store.getters.itemsCount;
        },
        totalPrice: function () {
            return Format.price(this.$store.getters.totalPrice);
        },
        subtotalPrice: function () {
            return Format.price(this.$store.getters.subtotalPrice);
        },
        totals: function () {
            var taxes = [];

            for (var i in this.$store.getters.taxes) {
                taxes.push({
                    value: Format.price(this.$store.getters.taxes[i].value),
                    text: this.$store.getters.taxes[i].text
                });
            }

            return {
                total: Format.price(this.$store.getters.totalPrice),
                subtotal: Format.price(this.$store.getters.subtotalPrice),
                taxes: taxes,
                discount: this.$store.getters.totals.discount,
                shipping: this.$store.getters.totals.shipping
            };
        },
        hasFreeShipping: function () {
            return this.$store.getters.hasFreeShipping;
        },
        freeShipping: function () {
            return this.$store.state.cart.free_shipping;
        },
        freeShippingText: function () {
            return this.$store.getters.freeShippingText;
        },
        hasTotalsLoaded: function () {
            return this.$store.getters.hasTotalsLoaded;
        }
    },
    methods: {
        removeCartItem: function (cartId) {
            this.$store.dispatch('removeCartItem', cartId);
        }
    }
});

// Added product to cart callback
rEvent.on('Cart.addedProduct', function (data) {
    if (data.response.upsell && data.response.upsell.active && !$('#up-sell').is(':visible') && !$('body').hasClass('disabled-up-sell')) {
        $.get(data.response.upsell.url, {}, function (html) {
            $('#up-sell').remove();
            $('body').append(html);
            $('#up-sell').modal();
            Eshop.preloader.hide();
            rEvent.dispatch('Cart.upsell.show');
        });
    } else {
        Eshop.alert(data.response.message);
        Eshop.preloader.hide();
    }
});

rEvent.on('App.mounted', function () {
    store.dispatch('fetchCart');
});
